import Chip from '@mui/material/Chip'
import { useTheme } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import React, { useCallback } from 'react'

import { COMMON } from 'theme/colors'
import { isValidHex } from 'utils/validations'

import type { ChipProps } from '@mui/material/Chip'

const DEFAULT_MAX_WIDTH = 200

export type TagChipTag = {
  tagName?: string | null
  tagColor?: string | null
}

type Props = Omit<ChipProps, 'onClick'> & {
  tag: TagChipTag
  onClick?: (event: React.MouseEvent<HTMLDivElement>, tag: TagChipTag) => void
  maxWidth?: number | string
}

const Tag: React.FC<Props> = ({ tag, size = 'small', onClick, maxWidth = DEFAULT_MAX_WIDTH, clickable = true, ...rest }) => {
  const theme = useTheme()
  const bgcolor = tag.tagColor
  const validatedBgcolor = bgcolor && isValidHex(bgcolor) ? bgcolor : COMMON.white
  const color = theme.palette.getContrastText(validatedBgcolor)
  const handleClick = useCallback((event: React.MouseEvent<HTMLDivElement>) => onClick?.(event, tag), [onClick, tag])

  return (
    <Chip
      {...rest}
      clickable={clickable}
      label={<Typography noWrap>{tag.tagName}</Typography>}
      size={size}
      sx={{
        backgroundColor: validatedBgcolor,
        color,
        '&:hover': {
          backgroundColor: validatedBgcolor,
          color,
        },
        ...(maxWidth && { maxWidth }),
      }}
      onClick={handleClick}
    />
  )
}

export default Tag
